import RelogioDePonto, {
  FinderRelogiosDePonto,
  RetornoRelogioDePonto,
} from 'Interface/RelogiosDePonto';
import Parametros from 'Interface/Requisicao';
import api from 'Service';

import { formData, paramsParaString } from '../utils';

const tag = 'RelogiosDePonto';

const url = '/relogios-de-ponto';

const apiExtendida = api
  .enhanceEndpoints({
    addTagTypes: [tag],
  })
  .injectEndpoints({
    endpoints: (construtor) => ({
      recuperarRelogiosDePonto: construtor.query<
        FinderRelogiosDePonto,
        Parametros | void
      >({
        query: (params) => `${url}?${paramsParaString(params)}`,
        providesTags: (resultado) =>
          resultado?.relogios_de_ponto
            ? [
                ...resultado.relogios_de_ponto.map(
                  ({ id }) => ({ type: tag, id } as const)
                ),
                { type: tag, id: 'LISTA' },
              ]
            : [{ type: tag, id: 'LISTA' }],
      }),
      recuperarRelogioDePonto: construtor.query<
        RetornoRelogioDePonto,
        string | number | Parametros
      >({
        query: (params) => {
          let id: number;
          let query: Parametros = {};

          if (['string', 'number'].includes(typeof params)) {
            id = params as number;
          } else {
            params = params as Parametros;

            id = params.id as number;
            query = paramsParaString(params);
          }

          return `${url}/${id}?${query}`;
        },
        providesTags: (resultado, erro, params) => {
          let id: number;

          if (['string', 'number'].includes(typeof params)) {
            id = params as number;
          } else {
            params = params as Parametros;

            id = params.id as number;
          }

          return [{ type: tag, id }];
        },
      }),
      adicionarRelogioDePonto: construtor.mutation<
        RelogioDePonto,
        Partial<RelogioDePonto>
      >({
        query: (dados) => ({
          url: url,
          method: 'POST',
          body: formData(dados, 'POST'),
        }),
        invalidatesTags: (resultado, erro) =>
          !erro ? [{ type: tag, id: 'LISTA' }] : [],
      }),
      editarRelogioDePonto: construtor.mutation<
        RelogioDePonto,
        Partial<RelogioDePonto> &
          Pick<RelogioDePonto, 'id'> & { options?: Parametros }
      >({
        query: ({ id, options, ...dados }) => ({
          url: `${url}/${id}?${paramsParaString({ options })}`,
          method: 'POST',
          body: formData(dados, 'PUT'),
        }),
        invalidatesTags: (resultado, erro, { id }) =>
          !erro ? [{ type: tag, id }] : [],
      }),
      removerRelogioDePonto: construtor.mutation<
        RelogioDePonto,
        Partial<RelogioDePonto> & Pick<RelogioDePonto, 'id'>
      >({
        query: ({ id, ...dados }) => ({
          url: `${url}/${id}`,
          method: 'DELETE',
          body: dados,
        }),
        invalidatesTags: (resultado, erro, { id }) =>
          !erro ? [{ type: tag, id }] : [],
      }),
    }),
    overrideExisting: false,
  });

export const {
  useRecuperarRelogiosDePontoQuery,
  useRecuperarRelogioDePontoQuery,
  useAdicionarRelogioDePontoMutation,
  useEditarRelogioDePontoMutation,
  useRemoverRelogioDePontoMutation,
} = apiExtendida;
